export default "__VITE_ASSET__22rQmWTh__$_?url__"